export const HomePath = "/(auth)";
export const LoginPath = "/(guest)";
export const AccountRecoveryPath = "/(guest)/account-recovery";
export const UsersPath = "/user-roles/users";
export const RolesPath = "/user-roles/roles";
export const ResidentsPath = "/residents";
export const AddResidentPath = "/residents/add";
export const ShiftHandoverDashboardPath = "/shift-handover";
export const LocationsPath = "/locations";
export const CalendarPath = "/calendar";
export const ErrorRoutePath = "/";
export const StatusFlagsPath = "/status-flags";
export const AssessmentsPath = "/assessments";
export const AuditLogsPath = "/audit-logs";
export const ReportsPath = "/reports";
export const PendingSignOffsPath = "/pending-sign-offs";
export const PendingSignOffsChecklistPath =
  "/pending-sign-offs/admission-checklist";
export const PendingSignOffsMedicationsPath = "/pending-sign-offs/medications";
export const PendingSignOffsAccidentsIncidentsPath =
  "/pending-sign-offs/accidents-and-incidents";
